import axios from 'axios'
import { call, put } from '@redux-saga/core/effects'
import { rcusError, rcusSuccess } from '../../../actions/rcus/actions'
import { PageSet } from '../../../types'
import { Action } from '../../../../common/store/sagas/root'
import { getRcus } from '../../../api/rcusGetter'
import { PaginatedResponse } from '../../../../types'

export function* sagaGetRcus({ payload }: Action<PageSet>) {
  try {
    const response: PaginatedResponse = yield call(getRcus, payload)
    yield put(rcusSuccess(response))
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      yield put(rcusError(error.response.data as unknown))
    } else {
      yield put(rcusError(error))
      throw error
    }
  }
}
